import ResetPasswordForm from '../../components/auth/ResetPasswordForm';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  return (
    <div className="reset-password-page">
      <div className="reset-password-page__container">
        <div className="reset-password-page__content">
          <div className="reset-password-page__logo">
            🚗
          </div>
          <h1 className="reset-password-page__title">溫柔小姊姊｜選物 x 微批發</h1>
          <ResetPasswordForm />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
